import { PushNotificationTokenType } from 'APP/model/pushNotifications/pushNotificationsModel.types';

import { unregisterNotifications } from './unregisterNotifications';

export const unsubscribeNotifications = async (): Promise<void> => {
  await Promise.all([
    unregisterNotifications(PushNotificationTokenType.default),
    unregisterNotifications(PushNotificationTokenType.voip),
  ]);
};
